/* URWizards dice analytics v2. No purchase, gtag, advertising or customer PII. */
(() => {
  'use strict';
  if (window.URDiceTracking) return;
  const VERSION='urwizards_dice_v2', KEY='ur_dice_recommendations_v2', TTL=30*60*1000;
  const allowed=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
  const mode=()=>window.Shopify?.theme?.role==='main'&&!window.Shopify?.designMode?'live':'qa';
  const safeId=value=>/^\d+$/.test(String(value))?String(value):'';
  const entry=element=>new URL(location.href).searchParams.get('dice_entry')==='product'?'product_entry':element?.dataset.standalone==='true'?'standalone':'home';
  const read=()=>{try{const data=JSON.parse(localStorage.getItem(KEY)||'[]');return Array.isArray(data)?data.filter(x=>x.version===VERSION&&x.mode===mode()&&Date.now()-x.at>=0&&Date.now()-x.at<TTL).slice(-20):[];}catch{return [];}};
  const write=data=>{try{localStorage.setItem(KEY,JSON.stringify(data.slice(-20)));}catch{}};
  function publish(name,data={}) {
    if(!allowed()){if(mode()==='qa')console.info('[UR Dice QA] waiting for analytics permission',{privacyApi:!!window.Shopify?.customerPrivacy});return false;}
    if(typeof window.Shopify?.analytics?.publish!=='function')return false;
    if(!['dice_roll','dice_result_view','dice_product_click','dice_add_to_cart','dice_entry_click'].includes(name))return false;
    try{
      const payload={schema:VERSION,mode:mode(),theme_id:String(window.Shopify?.theme?.id||''),...data};
      const result=window.Shopify?.analytics?.publish?.(`urwizards:${name}`,payload);
      if(mode()==='qa')console.info('[UR Dice QA]',name,{entry:payload.entry_location||'',mode:payload.mode});
      return result!==false;
    }catch{return false;}
  }
  function begin(element){
    if(!allowed()){if(mode()==='qa')console.info('[UR Dice QA] roll not tracked: analytics permission unavailable',{privacyApi:!!window.Shopify?.customerPrivacy});return null;}
    const context={version:VERSION,roll:crypto.randomUUID(),at:Date.now(),entry:entry(element),mode:mode()};
    publish('dice_roll',{entry_location:context.entry,material:element.ui.material.value,dice_format:element.ui.format.value,roll_id:context.roll});
    return context;
  }
  function remember(context,product,variantIds){
    if(!context||!allowed()||context.mode!==mode())return;
    const data={...context,product:safeId(product.id),handle:String(product.handle),variants:variantIds.map(safeId).filter(Boolean)};
    write([...read().filter(x=>x.roll!==context.roll),data]);
  }
  function properties(context,product,variant){
    if(!allowed()||!context||context.mode!==mode()||Date.now()-context.at>=TTL)return {};
    return {_discovery:'dice_roll',_discovery_version:VERSION,_discovery_mode:context.mode,_discovery_roll:context.roll,_discovery_at:String(context.at),_discovery_entry:context.entry,_discovery_product_id:safeId(product.id),_discovery_variant_id:safeId(variant.id)};
  }
  function productContext(form){
    if(!allowed())return null;
    const variant=safeId(form.elements.namedItem('id')?.value);
    const roll=new URL(location.href).searchParams.get('ur_dice');
    if(!roll||!variant)return null;
    return read().find(x=>x.roll===roll&&x.variants.includes(variant)&&decodeURIComponent(location.pathname).endsWith(`/products/${x.handle}`))||null;
  }
  function prepareForm(form){
    if(!(form instanceof HTMLFormElement))return;
    form.querySelectorAll('[data-ur-dice-property]').forEach(x=>x.remove());
    const context=productContext(form);if(!context)return;
    const variant={id:form.elements.namedItem('id').value};
    for(const [key,value]of Object.entries(properties(context,{id:context.product},variant))){
      const input=document.createElement('input');input.type='hidden';input.name=`properties[${key}]`;input.value=value;input.dataset.urDiceProperty='true';form.append(input);
    }
  }
  function added(response){
    if(!allowed()||!response?.id||response.status)return;
    const p=response.properties||{};
    if(p._discovery_version!==VERSION||p._discovery_mode!==mode()||String(response.variant_id||response.id)!==p._discovery_variant_id)return;
    publish('dice_add_to_cart',{entry_location:p._discovery_entry,product_id:p._discovery_product_id,variant_id:p._discovery_variant_id,roll_id:p._discovery_roll,add_path:'product_page'});
  }
  const sync=()=>document.querySelectorAll('form[action*="/cart/add"]').forEach(prepareForm);
  document.addEventListener('submit',e=>prepareForm(e.target),true);
  document.addEventListener('change',e=>{if(e.target.closest('product-form'))sync();},true);
  document.addEventListener('VARIANT_CHANGE',sync,true);
  document.addEventListener('reload',sync,true);
  document.addEventListener('click',e=>{
    const a=e.target.closest('a[data-ur-dice-entry]');
    if(a)publish('dice_entry_click',{entry_location:'product_entry'});
  });
  document.addEventListener('visitorConsentCollected',()=>{
    if(!allowed()){try{localStorage.removeItem(KEY);}catch{};document.querySelectorAll('[data-ur-dice-property]').forEach(x=>x.remove());}
    else sync();
  });
  window.URDiceTracking={version:VERSION,allowed,mode,begin,remember,properties,publish,prepareForm,added};
  if(window.Shopify?.loadFeatures&&!window.Shopify?.customerPrivacy)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error=>{sync();if(mode()==='qa')console.info('[UR Dice QA] privacy ready',{available:!!window.Shopify?.customerPrivacy,allowed:allowed(),error:!!error});});
  if(mode()==='qa')console.info('[UR Dice QA] helper ready',{privacyApi:!!window.Shopify?.customerPrivacy,allowed:allowed(),publisher:typeof window.Shopify?.analytics?.publish==='function'});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync,{once:true});else sync();
})();
